// extracted by mini-css-extract-plugin
export var container = "_8x-0";
export var containerTopRight = "_8x-1";